<template>
  <b-container>
    <div class="footer__last">
      <div class="footer__last">
      <span>{{ $t("2021") }}</span>
      <div class="break"></div>
      <a class="bd-url" @click="handleClick('ImportantNotices')" role="button" tabindex="0">{{ $t("notices") }} </a>
      <div class="break"></div>
      <a class="bd-url" @click="handleClick('TermsAndConditions')" role="button" tabindex="0">{{ $t("disclaimer") }}</a>
      <div class="break"></div>
      <a class="bd-url" @click="handleClick('PrivacyPolicyStatement')" role="button" tabindex="0">{{ $t("privacy") }}</a>
      </div>
      <div class="footer__icon-item d-flex align-items-center">
        <a href="https://www.w3.org/WAI/WCAG2AA-Conformance" target="_blank">
          <img style="width: 100px; height: auto;" alt="www.w3.org" src="@/assets/Footer/w3c.png" />
        </a>
        <a class="ml-3" @click="redirectBannerhk">
          <img alt="hk-logo" src="@/assets/Footer/footer_logo_hk.png" />
        </a>
      </div>
    </div>
  </b-container>
</template>

<script>
import NavbarSplitter from "@/components/NavbarSplitter";
export default {
  components: {
    NavbarSplitter,
  },
  methods: {
    handleClick(to) {
      this.$router.push({ name: to });
    },
    redirectBannerhk() {
      switch(this.$i18n.locale) {
        case "en": 
          window.open(`https://www.brandhk.gov.hk/en/`);
          break;
        case "zh_hk": 
          window.open(`https://www.brandhk.gov.hk/zh-hk/`);
          break;
        case "zh_cn": 
          window.open(`https://www.brandhk.gov.hk/zh-cn/`);
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
// .footer__last {
//   font-size: 0.75em;
//   display: flex;
//   align-items: center;
//   font-weight: 500;
//   justify-content: space-between;
// }
// .footer__last a {
//   cursor: pointer;
//   color: #005d99 !important;
// }
// .footer__last a:hover {
//   text-decoration: underline !important;
// }
// .footer__last .break {
//   height: 1em;
//   width: 1px;
//   // margin: 0 1rem;
//   background-color: #000;
// }
</style>

<i18n src="@/locales/parts/footer/BottomInfoNav.json" />

